import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const BubbleSort = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Bubble Sort"
    videos={[
      "https://www.youtube.com/embed/Dv4qLJcxus8"
    ]}
    takeaways={[]}
    questions={[
      "a) Can you improve the best-case complexity of bubble sort by optimizing the traditional algorithm? If yes, write the modified version of the algorithm and demonstrate how the improvement is achieved.",
      "Illustrate and Explain the working principle of Bubble Sort Algorithms using the following 7, 1, 3, 8, 2, 5 Numbers.",
      "Estimate the total number of comparisons in bubble sort needed when N=7 to arrange the given elements in ascending order. (N is the total number of elements present in the given array)"
    ]}
    exampleVideos={[]}
  />
);
}

export default BubbleSort;
